import { useTranslation } from 'react-i18next'
import mainLogo from '../svg/logoIconWhite.svg'

export const LogoIconWhiteWithText = () => {
  const { t } = useTranslation()

  return <img src={mainLogo} width="50px" height="auto" alt={t('a11y.alt.main-logo')} />
}
